const storageKey = (recipientId) =>
  `notificationBellAcknowledged:${String(recipientId)}`;

/** Unread count when the user last opened the notification bell (FB/IG-style badge dismiss). */
export function getBellAcknowledgedUnread(recipientId) {
  if (!recipientId) return 0;
  try {
    const raw = sessionStorage.getItem(storageKey(recipientId));
    if (raw == null || raw === "") return 0;
    const n = Number(raw);
    return Number.isFinite(n) && n >= 0 ? n : 0;
  } catch {
    return 0;
  }
}

export function setBellAcknowledgedUnread(recipientId, count) {
  if (!recipientId) return;
  try {
    const safe = Math.max(0, Math.floor(Number(count) || 0));
    sessionStorage.setItem(storageKey(recipientId), String(safe));
  } catch {
    // ignore quota / private mode
  }
}

export function clearBellAcknowledgedUnread(recipientId) {
  if (!recipientId) return;
  try {
    sessionStorage.removeItem(storageKey(recipientId));
  } catch {
    // ignore
  }
}
